module.exports = __webpack_public_path__ + "img/party_lower_1.286c0e4e.jpg";